import * as React from "react";
import type { SVGProps } from "react";

interface StartProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Start = ({ cancelled = false, ...props }: StartProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(.2 .2)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M9.55 0a9.55 9.55 0 1 1 0 19.1 9.55 9.55 0 0 1 0-19.1"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M9.55.75a8.8 8.8 0 1 1 0 17.6 8.8 8.8 0 0 1 0-17.6"
        />
        <circle cx={9.55} cy={9.55} r={7.5} fill="#60B100" />
        <path
          fill="#FFF"
          stroke="#000"
          strokeWidth={1.1}
          d="m7.31 4.103 7.336 5.044a.42.42 0 0 1 0 .693l-7.337 5.044a.42.42 0 0 1-.659-.346V4.45a.42.42 0 0 1 .66-.347Z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M6.82 18.712a1.88 1.88 0 0 0-.279 2.646l.588.727a1.88 1.88 0 0 0 2.301.5l3.97-1.979.144.158c1.867 1.968 4.921 2.257 7.1.632l.17-.132a5.35 5.35 0 0 0 1.82-5.437l-.016-.063.047-.048a1.88 1.88 0 0 0 .149-2.322l-.088-.118a1.88 1.88 0 0 0-2.145-.571l-.038.015-.012-.009c-1.868-1.348-4.437-1.378-6.332.03l-.175.137a1.6 1.6 0 0 0-.51 1.753l.03.073-1.037.84a1.66 1.66 0 0 0-1.807.034l-.115.085z"
        />
        <path
          fill="#000"
          d="M7.197 19.179a1.28 1.28 0 0 0-.19 1.802l.588.726c.378.467 1.03.608 1.568.34l4.195-2.09a.28.28 0 0 1 .348.081l.02.024c1.665 2.057 4.67 2.388 6.71.735a4.76 4.76 0 0 0 1.516-5.177l-.024-.068.024-.013.124-.089a1.277 1.277 0 0 0 .183-1.796 1.277 1.277 0 0 0-1.795-.195l.024-.018-.057-.049c-1.668-1.38-4.088-1.483-5.855-.182l-.175.135a1 1 0 0 0-.147 1.405l.037.046a.06.06 0 0 1-.009.083l-1.748 1.415a.06.06 0 0 1-.082-.008 1.06 1.06 0 0 0-1.49-.157zm.629.777 3.766-3.05a.06.06 0 0 1 .082.009 1.06 1.06 0 0 0 1.49.157l1.748-1.416a1.06 1.06 0 0 0 .156-1.49l-.036-.045.155-.12c1.479-1.074 3.533-.91 4.847.378l.138.143a.5.5 0 0 0 .838-.169.26.26 0 0 1 .083-.116.277.277 0 0 1 .39.046.277.277 0 0 1-.036.39.26.26 0 0 1-.174.06.5.5 0 0 0-.466.717c.763 1.57.36 3.47-1 4.57-1.61 1.304-3.985 1.042-5.305-.587l-.01-.014a1.28 1.28 0 0 0-1.58-.357l-4.195 2.09a.28.28 0 0 1-.344-.074l-.589-.727a.28.28 0 0 1 .042-.395"
        />
        <path
          fill="#000"
          d="M15.953 15.232a2.365 2.365 0 0 0-.337 3.299 2.3 2.3 0 0 0 3.259.352 2.365 2.365 0 0 0 .337-3.3 2.3 2.3 0 0 0-3.259-.351m.634.773a1.3 1.3 0 0 1 1.844.203 1.365 1.365 0 0 1-.19 1.901 1.3 1.3 0 0 1-1.844-.203 1.365 1.365 0 0 1 .19-1.9"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Start;
